import React from "react";
import CounterOne from "../../components/About/CounterOne";
import videoImg from "../../assets/images/resources/counter-one-img-1.jpg";
const counters = [
  {
    iconClass: "icon-schedule",
    end: 300,
    suffix: "+",
    text: "Successful Installations",
  },
  {
    iconClass: "icon-schedule",
    end: 2,
    suffix: "k",
    plus: true,
    text: "Skilled Engineers",
  },
  {
    iconClass: "icon-schedule",
    end: 3,
    suffix: "k",
    plus: true,
    text: "Satisfied Clients",
  },
];

const Features = () => {
  return (
    <>
      {/*Message One Start */}
      <CounterOne
        imageSrc={videoImg}
        videoId="jNQXAC9IVRw" // YouTube video ID
        videoCaption="Watch our video"
        tagline="Our Features"
        title="Innovative Solutions, Trusted Performance"
        // description="At Arch Elevators, we design and deliver elevator systems that simplify movement, enhance user safety, and align with modern architectural needs. With cutting-edge technology, expert craftsmanship, and a customer-first approach, we redefine vertical mobility."
        description="<p>
    At Arch Elevators, we design and deliver elevator systems that simplify movement, enhance user safety, and align with modern architectural needs. With cutting-edge technology, expert craftsmanship, and a customer-first approach, we redefine vertical mobility.
    
  </p>

  <ul>
    <li><strong>Professional Repair Teams:</strong> Arch trains highly skilled service teams to maintain top-quality repair and maintenance standards.</li>
    <li><strong>Robust Service System:</strong> Multiple service channels ensure reliable monitoring and control of repair quality.</li>
    <li><strong>24/7 All-Weather Support:</strong> Prompt assistance is available anytime, day or night.</li>
    <li><strong>Commitment to Excellence:</strong> A formal pledge ensures our dedication to the highest repair and maintenance standards.</li>
    <li><strong>Dedicated Project Care:</strong> Specialized staff regularly test and maintain large and medium-scale projects.</li>
  </ul>
  
    <p>Every service is designed to maximize reliability and customer satisfaction.</p>
  <p>With Arch Elevators, you move smarter, safer, and with complete peace of mind.</p>
  <br/>
  
  <p>Experience the Arch difference today!</p>
"
        counters={counters}
      />
      {/*Message One End */}
    </>
  );
};

export default Features;
